import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { IconButton, IconButtonProps, Popover } from '@material-ui/core'
import ColorizeIcon from '@material-ui/icons/Colorize'
import { ContentSection } from 'components/data/ContentSection/ContentSection'
import { LanguagesSelect } from 'components/data/LanguagesSelect/LanguagesSelect'
import { TextField } from 'components/inputs/TextField/TextField'
import { LabelTypeSelect } from 'components/data/LabelTypeSelect/LabelTypeSelect'

const selectStyles = css`
  min-width: 200px;
`

const StyledTextField = styled(TextField)`
  width: 100%;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 800px;
`

const InfoSection = styled(ContentSection)`
  flex: 1;
  margin-top: ${({ theme }) => theme.spacing(2.5)}px;
  min-width: 200px;
`

const TranslationLanguagesSelect = styled(LanguagesSelect)`
  ${selectStyles}
`

const StyledLabelTypeSelect = styled(LabelTypeSelect)`
  ${selectStyles}
`

const ColorPopover = styled(Popover)`
  & .MuiPopover-paper {
    overflow: visible;
  }
  & .MuiPaper-rounded {
    border-radius: 8px;
  }
`

const ColorTextField = styled(TextField)`
  margin-right: ${({ theme }) => theme.spacing(2)}px;
`

const ColorPickerContainer = styled.div`
  display: flex;
  align-items: center;
`

const ColorPickerButton = styled((props: IconButtonProps) => (
  <IconButton {...props}>
    <ColorizeIcon />
  </IconButton>
))``

interface UserColorCircleProps {
  $backgroundColor?: string
}

const ColorCircle = styled.div<UserColorCircleProps>`
  ${({ theme, $backgroundColor }) => css`
    margin-right: ${theme.spacing(1)}px;
    width: 32px;
    height: 32px;
    border: 1px solid ${theme.palette.text.primary};
    border-radius: 50%;
    background-color: ${$backgroundColor};
  `}
`

export {
  StyledTextField as TextField,
  Form,
  InfoSection,
  TranslationLanguagesSelect,
  ColorPopover,
  ColorTextField,
  ColorPickerContainer,
  ColorPickerButton,
  ColorCircle,
  StyledLabelTypeSelect as LabelTypeSelect
}
